import { FC, useRef, useState } from 'react';
import { repairStatusMap } from '../../config';
import styles from './index.less';
import { List, PullRefresh, Typography } from 'react-vant';
import { history } from '@umijs/max';
import { getTicketPage } from '@/service/repaire';
import NoData from '@/components/NoData';

interface RepairListProps {
  tabsKey: string;
}

const RepairList: FC<RepairListProps> = ({ tabsKey }) => {
  console.log(88, repairStatusMap)
  const [finished, setFinished] = useState<boolean>(false);
  const [workTicketList, setWorkTicketList] = useState<any>([]);
  const pageNum = useRef(1);


  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setWorkTicketList([]);

    const data = await getTicketPage({
      current: pageNum.current,
      pageSize: 10,
      ticketStatus: tabsKey,
    });
    const listData: any = [...workTicketList, ...data.rows];
    if (isRefresh || pageNum.current === 1) {
      setWorkTicketList(data.rows);
    } else {
      setWorkTicketList(listData);
    }

    if (
      data.rows.length === data.total ||
      data.rows.length < 10 ||
      !data.rows.length ||
      data.total === 0
    ) {
      // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1;
      setFinished(false); // 仍有数据可加载，保持为false
    }
  };

  const onRefresh = async () => {
    pageNum.current = 1;
    setFinished(true);
    setWorkTicketList([]);
    onLoadRefresh(true);
  };

  const viewDatail = (item: any) => {
    // history.push('/repairDetail');
    history.push(`/repairDetail?sequenceNbr=${item.sequenceNbr}`);
  };
  return (
    <div className={styles.container}>
      <PullRefresh onRefresh={onRefresh}>
        <List
          finished={finished}
          onLoad={onLoadRefresh}
          finishedText={!workTicketList?.length ? '' : '没有更多了'}
        >
         {workTicketList?.length !== 0 ? ( <>{workTicketList.map((item: any) => (
            <div className={styles.content} key={item.sequenceNbr} onClick={() =>viewDatail(item)}>
             <div
                className={styles.tag}
                style={{
                  backgroundColor:
                    item &&
                    item.ticketStatus &&
                    repairStatusMap[item.ticketStatus!]?.backGroundColor,
                  color: item && repairStatusMap[item.ticketStatus!]?.textColor,
                }}
              >
                 <img
                  src={
                    item &&
                    item.ticketStatus &&
                    repairStatusMap[item.ticketStatus!].icon
                  }
                  alt={'icon'}
                />
                <span>
                  {item &&
                    item.ticketStatus &&
                    repairStatusMap[item.ticketStatus].text}
                </span> 
              </div>
              <div className={styles['content-nav']}>
                {/* <p>{item.title}555</p> */}
                <div>
                  <Typography.Text
                    ellipsis={{
                      rows: 2,
                      symbol: '......',
                      suffixCount: 10,
                    }}
                  >
                    {item.ticketContent}
                  </Typography.Text>
                </div>
                <span>上报时间：{item.createTime}</span>
               
              </div>
              <div className={styles['content-icon']}>
                {item.firstCategoryName}
                {/* <RightOutlined /> */}
              </div>
            </div>
          ))} </>) : (
            <NoData />
          )}
        </List>
      </PullRefresh>
    </div>
  );
};

export default RepairList;
